import actionCreatorFactory from 'typescript-fsa';

/** テスト回答グループ */
export interface IGroup {
	groupTitle: string;
	quizCount: number;
	correctCount: number;
	questions: IQuestion[];
}

/** テスト回答共通 */
export interface IQuestionBase {
	answerResultMessage: string | null;
	answerResultType: AnswerResultTypes;
	answerScore: string;
	hint: string | null;
	hintFilePath: string | null;
	imageFilePath: string | null;
	questionID: string;
	questionNo: string;
	questionScore: string;
	questionText: string;
}

/** ラジオボタン形式テスト回答 */
export interface IRadioQuestion extends IQuestionBase {
	questionKind: QuestionKind.RADIO;
	answers?: IRadioAnswer[]; // シンプルモードのときは存在しない
}

/** テキスト記述形式テスト回答 */
export interface ITextQuestion extends IQuestionBase {
	questionKind: QuestionKind.TEXT;
	answers?: ITextAnswer[]; // シンプルモードのときは存在しない
}

/** チェックボックス形式テスト回答 */
export interface ICheckQuestion extends IQuestionBase {
	questionKind: QuestionKind.CHECK;
	answers?: ICheckAnswer[]; // シンプルモードのときは存在しない
}

/** プルダウン選択形式テスト回答 */
export interface ISelectQuestion extends IQuestionBase {
	questionKind: QuestionKind.SELECT;
	answers?: ISelectAnswer[]; // シンプルモードのときは存在しない
}

/** テスト回答 */
export type IQuestion =
	| IRadioQuestion
	| ITextQuestion
	| ICheckQuestion
	| ISelectQuestion;

type ExistsType<T> = T extends undefined ? never : T;

/** テスト回答 */
export type IAnswers = ExistsType<IQuestion['answers']>;

/** 結果形式 */
export enum AnswerResultTypes {
	PARTIAL = 0,
	RIGHT = 1,
	WRONG = 2,
}

/** テスト形式 */
export enum QuestionKind {
	RADIO,
	TEXT,
	CHECK,
	SELECT,
}

/** ラジオボタン形式回答 */
export interface IRadioAnswer {
	displayNum: string;
	options: IRadioOption[];
}

/** ラジオボタン形式選択肢 */
export interface IRadioOption {
	answerText: string;
	answerFlg: number;
	answerMessage: string;
}

/** テキスト記述形式回答 */
export interface ITextAnswer {
	answerText: string;
	answerFlg: number;
	answerMessage: string;
	displayNum: string;
}

/** チェックボックス形式回答 */
export interface ICheckAnswer {
	answerText: string;
	answerFlg: number;
	selected: boolean;
}

/** プルダウン選択形式回答 */
export interface ISelectAnswer {
	displayNum: string;
	options: ISelectOption[];
}

/** ラジオボタン形式選択肢 */
export interface ISelectOption {
	answerText: string;
	answerFlg: number;
	answerMessage: string;
}

const actionCreator = actionCreatorFactory();

/** eラーニングテスト結果設定アクションクリエータ */
export const setTestResultParams = actionCreator<{
	testTitle: string;
	score: number;
	scoreMessage: string;
	passFlg: boolean;
	paperType: number;
	groups: IGroup[];
	questionGroupDisplay: boolean;
}>('SET_TEST_RESULT_PARAMS');

/** eラーニングテスト結果初期化アクションクリエータ */
export const clearTestResultParams = actionCreator<{}>(
	'CLEAR_TEST_RESULT_PARAMS'
);



// WEBPACK FOOTER //
// ./src/actions/testResult.ts